import { render, staticRenderFns } from "./CardIntegration.vue?vue&type=template&id=6b497470&scoped=true"
import script from "./CardIntegration.vue?vue&type=script&lang=js"
export * from "./CardIntegration.vue?vue&type=script&lang=js"
import style0 from "./CardIntegration.vue?vue&type=style&index=0&id=6b497470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b497470",
  null
  
)

export default component.exports